import {applyMiddleware, legacy_createStore as createStore, Store} from "redux";
import logger from "redux-logger";
import {adminMiddleware} from "./main/components/admin/admin.middleware";
import {userSessionInitializer} from "./main/components/initialize/userSessionInitializer.middleware";
import {userSessionPersistence} from "./main/components/session/persistence/userSessionPersistence.middleware";
import {getConfig} from "./main/utils/envUtil";
import {applicationInitialState} from "./applicationState";
import {createRootReducer} from "./mainReducerMap";
import {thunk} from "redux-thunk";

const createLocalStore = () => {
    return createStore(
        createRootReducer(),
        applicationInitialState,
        applyMiddleware(
            logger,
            thunk,
            userSessionInitializer,
            userSessionPersistence,
            adminMiddleware,
        ),
    );
};

const createDefaultStore = () => {
    return createStore(
        createRootReducer(),
        applicationInitialState,
        applyMiddleware(
            thunk,
            userSessionInitializer,
            userSessionPersistence,
            adminMiddleware,
        ),
    );
};

export const store: Store<any, any> = (getConfig() && getConfig().FRONTEND_CONFIG_ENVIRONMENT === "local") ?
    createLocalStore() : createDefaultStore();